// extracted by mini-css-extract-plugin
export default {"container":"Rq-z","heading":"Sq-z","text":"Tq-z","info":"Uq-z","link":"Vq-z","fullMaxWidth":"Wq-z"};